// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-controls-tab {
  max-width: 1280px;
}

.phone-controls-tab h2 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: var(--wellsky-indigo);
}

.controls-grid {
  display: grid;
  grid-template-columns: minmax(400px, 1.2fr) minmax(340px, 1fr);
  gap: 20px;
  align-items: start;
}

.controls-grid-left,
.controls-grid-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

@media (max-width: 900px) {
  .controls-grid {
    grid-template-columns: 1fr;
  }
}

.alert {
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
}

.alert-error {
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  color: #c62828;
}

.call-status-card {
  background: var(--wellsky-white);
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid var(--wellsky-blue);
}

.call-status-card h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: var(--wellsky-indigo);
}

.call-status-card p {
  margin: 8px 0;
  font-size: 13px;
  color: var(--wellsky-indigo);
  opacity: 0.7;
}

/* ── Queue Section ─────────────────────────────────────── */

.queue-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.queue-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.queue-header h2 {
  margin: 0;
  font-size: 18px;
}

.queue-updated {
  margin: 0 0 12px;
  font-size: 12px;
  color: #888;
}

.queue-summary-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  padding: 6px 14px;
}

.queue-summary-number {
  font-size: 22px;
  font-weight: 700;
  color: #2e7d32;
  line-height: 1;
}

.queue-summary-label {
  font-size: 11px;
  color: #555;
}

/* Status messages */
.queue-answer-success,
.queue-answer-error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 14px;
}

.queue-answer-success {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  color: #2e7d32;
}

.queue-answer-error {
  background: #ffebee;
  border: 1px solid #ef9a9a;
  color: #c62828;
}

.queue-success-icon {
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.queue-dismiss-btn {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  padding: 0 4px;
  flex-shrink: 0;
}

.queue-dismiss-btn:hover {
  opacity: 1;
}

/* Loading / empty states */
.queue-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding: 30px 0;
  justify-content: center;
}

.queue-loading-spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #e0e0e0;
  border-top-color: var(--wellsky-blue);
  border-radius: 50%;
  animation: queue-spin 0.8s linear infinite;
}

.queue-load-error {
  background: #ffebee;
  border: 1px solid #ef9a9a;
  border-radius: 8px;
  padding: 14px;
  color: #c62828;
  font-size: 14px;
}

.queue-empty {
  color: #888;
  font-size: 14px;
  padding: 30px 0;
  text-align: center;
}

/* Team selector */
.queue-team-selector-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.queue-team-selector-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}

.queue-team-select {
  flex: 1;
  max-width: 340px;
  padding: 8px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  background: white;
  cursor: pointer;
}

.queue-team-select:focus {
  outline: 2px solid var(--wellsky-blue);
  outline-offset: 1px;
}

/* Queue panel */
.queue-panel {
  background: white;
  border-radius: 10px;
  border: 2px solid #e0e0e0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);
  overflow: hidden;
}

.queue-panel-main {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
}

.queue-panel-count {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex: 1;
}

.queue-caller-count {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.queue-caller-count.active {
  color: #2e7d32;
}

.queue-caller-count.zero {
  color: #bdbdbd;
}

.queue-caller-label {
  font-size: 13px;
  color: #666;
}

.queue-pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4caf50;
  flex-shrink: 0;
  animation: queue-pulse-anim 1.8s ease-in-out infinite;
  margin-left: 4px;
}

.queue-empty-note {
  padding: 16px 20px;
  color: #aaa;
  font-size: 13px;
  margin: 0;
}

/* Answer button */
.queue-answer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 7px;
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  flex-shrink: 0;
}

.queue-answer-btn.ready {
  background: #43a047;
  color: white;
}

.queue-answer-btn.ready:hover:not(:disabled) {
  background: #388e3c;
  transform: translateY(-1px);
}

.queue-answer-btn.disabled,
.queue-answer-btn:disabled {
  background: #f5f5f5;
  color: #bdbdbd;
  cursor: not-allowed;
}

.queue-btn-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: queue-spin 0.7s linear infinite;
}

@keyframes queue-spin {
  to { transform: rotate(360deg); }
}

@keyframes queue-pulse-anim {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(0.85); }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/PhoneControlsTab.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,YAAY;AACd;;AAEA,6DAA6D;;AAE7D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,YAAY,YAAY,EAAE,sBAAsB,EAAE;AACpD","sourcesContent":[".phone-controls-tab {\n  max-width: 1280px;\n}\n\n.phone-controls-tab h2 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n  color: var(--wellsky-indigo);\n}\n\n.controls-grid {\n  display: grid;\n  grid-template-columns: minmax(400px, 1.2fr) minmax(340px, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.controls-grid-left,\n.controls-grid-right {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n@media (max-width: 900px) {\n  .controls-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.alert {\n  padding: 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.alert-error {\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  color: #c62828;\n}\n\n.call-status-card {\n  background: var(--wellsky-white);\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid var(--wellsky-blue);\n}\n\n.call-status-card h3 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  color: var(--wellsky-indigo);\n}\n\n.call-status-card p {\n  margin: 8px 0;\n  font-size: 13px;\n  color: var(--wellsky-indigo);\n  opacity: 0.7;\n}\n\n/* ── Queue Section ─────────────────────────────────────── */\n\n.queue-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.queue-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.queue-header h2 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.queue-updated {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: #888;\n}\n\n.queue-summary-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #e8f5e9;\n  border: 1px solid #c8e6c9;\n  border-radius: 8px;\n  padding: 6px 14px;\n}\n\n.queue-summary-number {\n  font-size: 22px;\n  font-weight: 700;\n  color: #2e7d32;\n  line-height: 1;\n}\n\n.queue-summary-label {\n  font-size: 11px;\n  color: #555;\n}\n\n/* Status messages */\n.queue-answer-success,\n.queue-answer-error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.queue-answer-success {\n  background: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  color: #2e7d32;\n}\n\n.queue-answer-error {\n  background: #ffebee;\n  border: 1px solid #ef9a9a;\n  color: #c62828;\n}\n\n.queue-success-icon {\n  font-size: 18px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.queue-dismiss-btn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.6;\n  padding: 0 4px;\n  flex-shrink: 0;\n}\n\n.queue-dismiss-btn:hover {\n  opacity: 1;\n}\n\n/* Loading / empty states */\n.queue-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #666;\n  padding: 30px 0;\n  justify-content: center;\n}\n\n.queue-loading-spinner {\n  width: 18px;\n  height: 18px;\n  border: 3px solid #e0e0e0;\n  border-top-color: var(--wellsky-blue);\n  border-radius: 50%;\n  animation: queue-spin 0.8s linear infinite;\n}\n\n.queue-load-error {\n  background: #ffebee;\n  border: 1px solid #ef9a9a;\n  border-radius: 8px;\n  padding: 14px;\n  color: #c62828;\n  font-size: 14px;\n}\n\n.queue-empty {\n  color: #888;\n  font-size: 14px;\n  padding: 30px 0;\n  text-align: center;\n}\n\n/* Team selector */\n.queue-team-selector-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.queue-team-selector-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  white-space: nowrap;\n}\n\n.queue-team-select {\n  flex: 1;\n  max-width: 340px;\n  padding: 8px 12px;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #333;\n  background: white;\n  cursor: pointer;\n}\n\n.queue-team-select:focus {\n  outline: 2px solid var(--wellsky-blue);\n  outline-offset: 1px;\n}\n\n/* Queue panel */\n.queue-panel {\n  background: white;\n  border-radius: 10px;\n  border: 2px solid #e0e0e0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);\n  overflow: hidden;\n}\n\n.queue-panel-main {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 16px 20px;\n}\n\n.queue-panel-count {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex: 1;\n}\n\n.queue-caller-count {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.queue-caller-count.active {\n  color: #2e7d32;\n}\n\n.queue-caller-count.zero {\n  color: #bdbdbd;\n}\n\n.queue-caller-label {\n  font-size: 13px;\n  color: #666;\n}\n\n.queue-pulse {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #4caf50;\n  flex-shrink: 0;\n  animation: queue-pulse-anim 1.8s ease-in-out infinite;\n  margin-left: 4px;\n}\n\n.queue-empty-note {\n  padding: 16px 20px;\n  color: #aaa;\n  font-size: 13px;\n  margin: 0;\n}\n\n/* Answer button */\n.queue-answer-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 24px;\n  border-radius: 7px;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, transform 0.1s;\n  flex-shrink: 0;\n}\n\n.queue-answer-btn.ready {\n  background: #43a047;\n  color: white;\n}\n\n.queue-answer-btn.ready:hover:not(:disabled) {\n  background: #388e3c;\n  transform: translateY(-1px);\n}\n\n.queue-answer-btn.disabled,\n.queue-answer-btn:disabled {\n  background: #f5f5f5;\n  color: #bdbdbd;\n  cursor: not-allowed;\n}\n\n.queue-btn-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: queue-spin 0.7s linear infinite;\n}\n\n@keyframes queue-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes queue-pulse-anim {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50%       { opacity: 0.5; transform: scale(0.85); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
